import React from 'react';
import './footer.css';

export default function Footer(){
  return (
    <footer className="zm-footer">
      <div className="zm-container zm-footer-inner">
        <div>
          <div className="logo">ZeitaMax</div>
          <div className="tag">Connecting Potential</div>
        </div>
        <div className="links">
          <div>zeitamax.info@gmail.com</div>
          <div>+91 9848754756</div>
        </div>
      </div>
    </footer>
  )
}
